import { useMemo } from 'react';

import { useDefaultEvents } from '@Components/Grid';

export default function useEvents() {
  const { handleDeleteEntry } = useDefaultEvents()

  return useMemo(() => ({
    handleDeleteEntry,
  }), [handleDeleteEntry])
}
